import React, { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'

import './ServePost.css'

import NavHeader from '../../Components/NavHeader'
import SecondFooter from '../../Components/SecondFooter'
import TopBtn from '../../Components/TopBtn'
import MobileNavHeader from '../../Components/MobileNavHeader'
import MobileNav from '../../Components/MobileNav'
import MobileFooter from '../../Components/MobileFooter'

import visual from '../../assets/icons/visual_icon.svg'

import VisualPost1 from './VisualContent/VisualPost1'
import VisualPost2 from './VisualContent/VisualPost2'
import VisualPost3 from './VisualContent/VisualPost3'
import VisualPost4 from './VisualContent/VisualPost4'
import VisualPost5 from './VisualContent/VisualPost5'
import VisualPost6 from './VisualContent/VisualPost6'
import VisualPost7 from './VisualContent/VisualPost7'
import VisualPost8 from './VisualContent/VisualPost8'
import VisualPost9 from './VisualContent/VisualPost9'
import VisualPost10 from './VisualContent/VisualPost10'
import NotFound from '../NotFound'

function VisualPostHeader() {

    const postInfo = [
        { id: 1, title: 'Pyeonteilbar', date: '22.05.07 ~ 22.12.07', type: 'Graphic'},
        { id: 2, title: 'WWW', date: '21.12.20 ~ 22.12.17', type: 'BX'  },
        { id: 3, title: 'Whithin a trend', date: '23.10 ~ 23.11', type: 'Editorial' },
        { id: 4, title: 'ChaDaDam', date: '24.01 ~ 24.02', type: 'BX' },
        { id: 5, title: 'HONO 23f/w', date: '23.10 ~ 23.11', type: 'BX' },
        { id: 6, title: 'NUVEO', date: '23.10. ~ 23.11', type: 'BX' },
        { id: 7, title: 'Oliveyoung Live', date: '21.12. ~ 22.09', type: 'Graphic' },
        { id: 8, title: 'cassttecorner', date: '23.11. ~ 23.12', type: 'BX' },
        { id: 9, title: 'Oliveyoung TV', date: '21.12. ~ 22.09', type: 'Graphic' },
        { id: 10, title: 'PURE', date: '26.02.07 ~ 26.03.10', type: 'BX'},
    ]
    const [post, setPost] = useState();
    const [notFound, setNotFound] = useState(true);
    const [isModalOpen, setIsModalOpen] = useState(false);

    let postId = useParams();
    let navigate = useNavigate();
    function toVisual() {
        navigate('/visual')
    }

    useEffect(() => {
        window.scrollTo(0, 0);
      }, []);
      
    useEffect(() => {
        if (postId.id === '1') {
            setNotFound(false)
            setPost(<VisualPost1 />)
        }
        else if (postId.id === '2') {
            setNotFound(false)
            setPost(<VisualPost2 />)
        }
        else if (postId.id === '3') {
            setNotFound(false)
            setPost(<VisualPost3 />)
        }
        else if (postId.id === '4') {
            setNotFound(false)
            setPost(<VisualPost4 />)
        }
        else if (postId.id === '5') {
            setNotFound(false)
            setPost(<VisualPost5 />)
        }
        else if (postId.id === '6') {
            setNotFound(false)
            setPost(<VisualPost6 />)
        }
        else if (postId.id === '7') {
            setNotFound(false)
            setPost(<VisualPost7 />)
        }
        else if (postId.id === '8') {
            setNotFound(false)
            setPost(<VisualPost8 />)
        }
        else if (postId.id === '9') {
            setNotFound(false)
            setPost(<VisualPost9 />)
        }
        else if (postId.id === '10') {
            setNotFound(false)
            setPost(<VisualPost10 />)
        }
    }, [])

    return (
        <div className='page'>
            <NavHeader isNav={true} isAbout={false} isBlog={false} />
            <MobileNavHeader setIsModalOpen={setIsModalOpen} />
            {isModalOpen ? <MobileNav setIsModalOpen={setIsModalOpen} /> : null}
            {!notFound ?
                <div className='serve-post-body'>
                    <TopBtn />
                    <div className='serve-post-btn-n-filter'>
                        <div className='serve-back-btn' onClick={toVisual}>Back</div>
                        <div className='serve-filter'>{postInfo[postId.id - 1].type}</div>
                    </div>
                    <img id='servePostLogoFashion' src={visual} alt="" />
                    <div className='serve-post-title'>{postInfo[postId.id - 1].title}</div>
                    <div className='serve-post-subtitle'>{postInfo[postId.id - 1].date}</div>
                    {post}
                </div>
                :<NotFound />}
            <SecondFooter fashion={false} visual={true} media={false}/>
            <MobileFooter />
        </div>
    )
}

export default VisualPostHeader